<button class="btn {{type}}" [class.disabled]="disabled" (click)="saveClickEvent()" [disabled]="disabled">
  {{ text }}
  <ng-content></ng-content>
</button>
